import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PageList from '../../../components/PageListAPI'
import { journalSystemsGetList, journalSystemsDeleteById } from '../../../api/list'

export default function SystemsList() {
  const location = useLocation()
  const history = useHistory()
  return <div className='App-paper'>
    <PageList
      title='Системы'
      name='systems-list'
      columns={[{ id: 'code', name: 'Код', width:50 }, { id: 'name', name: 'Наименование' }]}
      createItem={true}
      deleteItem={true}
      loadAPI={{
        request: journalSystemsGetList,
      }}
      deleteAPI={journalSystemsDeleteById}
      headerInit={{
        sortBy: 'code',
        sortDirection: 'desc',
      }}
      location={location}
      history={history}
      click={false}
    />
  </div>
}